/**
 * Created by Bart Decorte
 * Date: 2019-07-12
 * Time: 09:41
 */
import LoadingStateImage from './LoadingStateImage';

class GalleryTile extends LoadingStateImage() {
  constructor(params) {
    super(params);
  }
}

export default GalleryTile;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/GalleryTile.js